import type UserGroupRequestModel from 'ab-requestModels/userGroup.requestModel';

import { isValidTextInput } from '@acceligentllc/shared/utils/text';

export function validate(values: UserGroupRequestModel) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Name is required';
	}

	return errors;
}
